export enum EnumHomePageAnchors {
	TECHNOLOGY = 'tech',
	TEAM = 'team',
	BROADTECH = 'broadtech',
	INTERACTION = 'interactions',
	HIT = 'hit',
	STARTUP = 'startup',
	BUSINESS = 'business',
	PERFORMANCE = 'performance',
}
